import { render, staticRenderFns } from "./BalanceHistories.vue?vue&type=template&id=15a47408"
import script from "./BalanceHistories.vue?vue&type=script&lang=js"
export * from "./BalanceHistories.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports